import React from "react";
import Spinner from "react-webpack-spinner";
import { Link } from "react-router";

class ResetPassword extends React.Component {
  password1 = React.createRef();
  password2 = React.createRef();

  resetPassword = () => {
    const { token } = this.props;

    this.props.onSend(
      this.password1.current.value,
      this.password2.current.value,
      token
    );
  };

  componentDidMount() {
    this.props.onReset();
  }

  render() {
    const {
      isResettingPassword,
      resetPasswordFailed,
      passwordReset
    } = this.props;

    if (isResettingPassword) {
      return (
        <div className="flex-1-1 has-text-centered">
          <Spinner width={32} height={32} color="#000" />
        </div>
      );
    }

    if (passwordReset) {
      return (
        <div className="content">
          <h1 className="title">Passwort erfolgreich gesetzt</h1>
          <p>
            Ihr Passwort wurde neu gesetzt. Sie können sich nun damit anmelden.
          </p>
          <Link className="button is-success" to="/login">
            zur Anmeldung
          </Link>
        </div>
      );
    }

    return (
      <div className="content">
        <h1 className="title">Passwort zurücksetzen</h1>
        {resetPasswordFailed && (
          <article className="message is-warning">
            <div className="message-header">Fehler</div>
            <div className="message-body">
              Das Passwort konnte nicht zurückgesetzt werden. Bitte prüfen Sie
              Ihre Eingabe.
            </div>
          </article>
        )}
        <p>Bitte geben Sie ihr neues Passwort hier ein:</p>
        <p>
          <input
            className="input"
            ref={this.password1}
            type="password"
            placeholder="Passwort"
          />
        </p>
        <p>
          <input
            className="input"
            ref={this.password2}
            type="password"
            placeholder="Passwort wiederholen"
          />
        </p>
        <p>
          <button className="button is-success" onClick={this.resetPassword}>
            Neues Passwort setzen
          </button>
        </p>
      </div>
    );
  }
}

export default ResetPassword;



/** WEBPACK FOOTER **
 ** ./src/components/ResetPassword.jsx
 **/